import { render, staticRenderFns } from "./BaseAsideNavItemGroup.vue?vue&type=template&id=b32c3df2&scoped=true"
import script from "./BaseAsideNavItemGroup.vue?vue&type=script&lang=js"
export * from "./BaseAsideNavItemGroup.vue?vue&type=script&lang=js"
import style0 from "./BaseAsideNavItemGroup.vue?vue&type=style&index=0&id=b32c3df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32c3df2",
  null
  
)

export default component.exports